import React, { useState } from "react";
import * as Icon from "react-feather";

//@MUI
import {
  Box,
  Button,
  MenuList,
  Popover,
  Typography,
  Select,
  FormControl,
  MenuItem,
} from "@material-ui/core";
import {
  CaretLeft,
  CheckSquare,
  PaintBrushHousehold,
  Pencil,
  Share,
  Funnel,
} from "phosphor-react";
import {
  SortButton,
  TableViewToggleButtons,
  ToggleButton,
} from "../../CommonComponents/CommonButtons/CommonButtons.Component.jsx";
import AddBulkAddButtons from "../../Utilities/Add&BulkAddButtons/Add&BulkAddButtons.jsx";
import BreadCrumb from "../../Utilities/BreadCrumb/BreadCrumb.jsx";
import StatusViewer from "../../Utilities/StatusViewer/StatusViewer.jsx";
import TrackableStats from "../../Utilities/TrackableStats/TrackableStats.jsx";
import useStyles from "./ShotsPageTools.styles";
import CommonFilterComponent from "../../Utilities/CommonFilterComponent/CommonFilterComponent.jsx";

export default function ShotsPageTools(props) {
  const classes = useStyles();
  const [nameStatus, setnameStatus] = React.useState("");
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [sliderState, setSliderState] = React.useState(0);

  React.useEffect(() => {
    if (props.sliderState > 0) {
      setSliderState(props.sliderState);
      sessionStorage.setItem("sliderState", `${sliderState}`);
    } else setSliderState(sessionStorage.getItem("sliderState"));
  }, [props.sliderState, sliderState]);

  React.useEffect(() => {
    if (props?.filterValues?.status && props?.status?.length) {
      setnameStatus(
        props?.status?.filter((e) => e?.id === props?.filterValues.status)[0]
          ?.name || "",
      );
    }
  }, [props.filterValues.status, props.status]);

  if (sessionStorage.getItem("sliderState") === null)
    sessionStorage.setItem("sliderState", 0);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openButtonPopover, setOpenButtonPopover] = React.useState(null);

  const handleButtonPopoverClick = (event) => {
    setOpenButtonPopover(event.currentTarget);
  };

  const handleButtonPopoverClose = () => {
    setOpenButtonPopover(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      {props.isMultiSelectEnabled ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              startIcon={<CaretLeft />}
              onClick={() => {
                props.handleToggleMultiSelect();
              }}
              className={classes.backButton}
            >
              Back
            </Button>
            <Button
              onClick={handleClick}
              sx={{ width: "100%", p: 0 }}
              disabled={!props.selectedShots?.length}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "white",
                  // backgroundColor: "#252A38",
                  p: "6px 12px",
                  // borderRadius: "10px",
                  width: "100%",
                  justifyContent: "space-between",
                  // border: "2px solid #606479",
                }}
              >
                <Pencil />
                <Typography>Update Status</Typography>
              </Box>
            </Button>

            {/* Popover */}
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  backgroundColor: "#252A38",
                  borderRadius: "12px",
                  border: "1px solid #3E4759",
                  boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.25)",
                  minWidth: 260,
                  mt: "8px",
                },
              }}
            >
              <MenuList
                sx={{
                  p: "8px",
                  backgroundColor: "#252A38",
                  border: "1px solid #606479",
                  borderRadius: "10px",
                }}
              >
                {props?.status?.map((sin) => (
                  <MenuItem
                    key={sin.id}
                    onClick={() => props.handleBulkUpdateStatus(sin.id)}
                    className={classes.menuItem}
                  >
                    <StatusViewer status={sin} />
                  </MenuItem>
                ))}
              </MenuList>
            </Popover>
            <Button
              startIcon={<PaintBrushHousehold />}
              className={
                !props.selectedShots?.length
                  ? classes.disabledButton
                  : classes.activeButton
              }
              onClick={() => props.handleClearSelection()}
            >
              Clear Selection
            </Button>
          </div>
        </>
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <BreadCrumb />
            <TrackableStats stats={props.shotsStats} type={"Shots"} />
          </div>
          <div className={classes.container}>
            <Button
              startIcon={<CheckSquare />}
              style={{ minWidth: "0px", padding: "4px 7px" }}
              onClick={() => props.handleToggleMultiSelect()}
            >
              <Typography className={classes.checkBoxText}>
                Multi Select
              </Typography>
            </Button>
            <div>
              <ToggleButton handleToggler={props.handleShotPageToggler} />
            </div>
            <TableViewToggleButtons
              isTogglerOn={props.isToggleView}
              handleToggle={props.handleToggleView}
            />
            <div>
              <SortButton
                onSubmit={props.onSubmit}
                defaultvalue={props.defaultvalue}
              />
            </div>
            <div>
              <FormControl variant="outlined" className={classes.formControl}>
                <div
                  style={{ justifyContent: "space-between" }}
                  className={classes.dropdownDiv}
                >
                  <text className={classes.selectText}>
                    {props.filterValues.status
                      ? nameStatus
                      : "Select By Status"}
                  </text>
                  <Icon.ChevronDown className={classes.iconStyle} />
                </div>
                <Select
                  className={classes.formLabelText}
                  labelId="demo-simple-select-outlined-label"
                  id="selectStatus"
                  label="Select Status"
                  value={props.filterValues.status}
                  onChange={(event) => {
                    props.handleStatusChange(event.target.value[0]);
                    setnameStatus(event.target.value[1]);
                  }}
                  MenuProps={{
                    classes: {
                      paper: classes.dropDown,
                    },
                  }}
                >
                  <MenuItem value={["", "None"]}>
                    <em>None</em>
                  </MenuItem>
                  {props.status &&
                    props.status.map((el) => (
                      <MenuItem value={[el.id, el.name]} key={el.id}>
                        {el.name} - {el.id}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            <Button
              size="small"
              variant="outlined"
              title="Filter"
              style={{
                border: "2px solid #6C65D9",
                borderRadius: "10px",
                padding: "10px",
                textTransform: "none",
                color: "white",
              }}
              onClick={() => setIsFilterDrawerOpen(true)}
            >
              <Funnel size={20} />
            </Button>
            <Button
              size="small"
              variant="outlined"
              style={{
                border: "2px solid #6C65D9",
                borderRadius: "10px",
                padding: "10px",
                textTransform: "none",
                color: "white",
                "&:hover": {
                  border: "2px solid #6C65D9",
                  backgroundColor: "#252A38",
                },
              }}
              onClick={props.handleOpenExportModal}
            >
              <Share size={20} />
            </Button>
            <div>
              <Button
                size="small"
                className={classes.shotsPageNewShotButton}
                disableElevation
                onClick={handleButtonPopoverClick}
              >
                <Icon.Plus className={classes.plusIcon} />
                New
              </Button>
            </div>
            <AddBulkAddButtons
              openButtonPopover={openButtonPopover}
              handleButtonPopoverClose={handleButtonPopoverClose}
              openNewModal={props.handleNewCreateModalOpen}
              openImportModal={props.handleOpenBulkImportModal}
              option2={props.handleMultiCreateModalOpen}
              trackableType="shot"
            />
          </div>
        </>
      )}
      <CommonFilterComponent
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        trackableType="shot"
        projectId={props.projectId}
      />
    </div>
  );
}
